import { defaultExpandedId } from '../config/ids';

export const setDefaultExpanded = (expanded: string[]): void => {
  localStorage.setItem(defaultExpandedId, JSON.stringify(expanded));
};
